import { Component, Input } from '@angular/core';

@Component({
  selector: 'kng-expand-collapse',
  templateUrl: './kng-expand-collapse.component.html',
  styleUrls: ['./kng-expand-collapse.component.less']
})
export class KngExpandCollapseComponent {

  @Input()
  public title: string;
  public expanded: boolean = false;

  constructor() { }

  toggleExpand() {
    this.expanded = ! this.expanded;
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/layout/kingswell/kng-expand-collapse/kng-expand-collapse.component.ts